import React from 'react';

const CustomLinkInactive = ({text}) => {
    return      <div className='react_link'>
                    <p className='link inactive'>
                        {text}
                    </p>
                </div>
};

export default CustomLinkInactive;